import axios from 'services/network/axios';

export const Register = (data) => axios.post('User/Register', data);
export const Verify = (data) => axios.post('User/Verify', data);
export const SendVerifyAgain = (data) => axios.post('User/SendVerifyAgain', data);

export const GetLocale = () => axios.get('User/GetLocale');
export const UpdateLocale = (data) => axios.post('User/UpdateLocale', data);

export const ChangeAvatar = (data) => axios.post('User/ChangeAvatar', data, {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
    }
});

